import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { DocumentsService } from "../../../../auth/service/documents.service";
import moment from "moment";

@Component({
  selector: "app-my-documents",
  templateUrl: "./my-documents.component.html",
  styleUrls: ["./my-documents.component.scss"],
})
export class MyDocumentsComponent implements OnInit {
  public documents: any = [];

  constructor(
    private _documentService: DocumentsService,
    public _utilsService: UtilsService,
  ) {}

  async ngOnInit() {
    this.documents = await this._documentService.getMyDocuments();
    this.documents = this.documents.filter((doc) => doc.document_data.require_acception === 1 || doc.document_data.require_signature === 1);
    this.documents = this.documents.sort((a, b) => (moment(a.send_date) < moment(b.send_date) ? 1 : -1));
    this.documents = this.documents.slice(0, 5);
  }
}
